(() => {
  if (window.shineCollectionAccessibilityBound) return;
  window.shineCollectionAccessibilityBound = true;
  const boundVideos = new WeakSet();
  const stops = new Set();
  const previewAllowed = () => matchMedia('(hover: hover) and (pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) entry.target.dispatchEvent(new Event('shine:stop-preview'));
  })) : null;
  const enhance = () => {
    document.querySelectorAll('[data-shine-hover-video]').forEach(video => {
      if (boundVideos.has(video)) return;
      boundVideos.add(video);
      const card = video.closest('.sgd-collection-card__image');
      let active = false, generation = 0;
      const stop = () => {
        active = false; generation++;
        video.pause(); card.classList.remove('is-video-playing');
        if (video.readyState > 0) video.currentTime = 0;
      };
      const start = () => {
        if (active || !previewAllowed()) return;
        active = true;
        const attempt = ++generation;
        video.muted = true;
        const source = video.querySelector('source');
        if (!source.hasAttribute('src')) {source.src = source.dataset.src; video.load();}
        const playback = video.play();
        if (playback) playback.then(() => { if (!active) stop(); }).catch(() => { if (generation === attempt) stop(); });
      };
      video.addEventListener('playing', () => { if (active) card.classList.add('is-video-playing'); else stop(); });
      video.addEventListener('error', stop);
      card.addEventListener('pointerenter', start);
      card.addEventListener('pointerleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
      card.addEventListener('shine:stop-preview', stop);
      stops.add(() => {if (!card.isConnected) {observer?.unobserve(card); return false;} stop(); return true;});
      observer?.observe(card);
    });
    document.querySelectorAll('main toolbar-item .label-tab, main toolbar-item [data-sort-by-item], main .sidebarBlock-heading').forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
    });
    document.querySelectorAll('main toolbar-item .label-tab.hidden-on-desktop').forEach(element => element.setAttribute('aria-label', 'Sort products'));
    document.querySelectorAll('main .halo-sidebar-header .title').forEach(element => { element.textContent = 'Filter jewellery'; });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.matches('main toolbar-item .label-tab, main toolbar-item [data-sort-by-item], main .sidebarBlock-heading')) return;
    event.preventDefault();
    event.target.click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
  const stopAll = () => stops.forEach(stop => {if (!stop()) stops.delete(stop);});
  document.addEventListener('visibilitychange', () => {if (document.hidden) stopAll();});
  window.addEventListener('blur', stopAll);
  // The theme replaces filtering/sorting fragments after AJAX responses.
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) enhance();
  }).observe(main, {childList: true, subtree: true});
})();
